import { render, staticRenderFns } from "./PlanActOfPurchaseModal.vue?vue&type=template&id=4fb0bd6f"
import script from "./PlanActOfPurchaseModal.vue?vue&type=script&lang=js"
export * from "./PlanActOfPurchaseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports